import React, { useState, useEffect } from 'react';
import axios from 'axios'
import fileDownload from 'js-file-download'
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import { Auth } from 'aws-amplify';
import { useDispatch, useSelector } from 'react-redux';
import AsOfDate from '../../common/Reports/AsOfDate';
import StartEndCounty from '../../common/Reports/StartEndCounty';
import StartEnd from '../../common/Reports/StartEnd';
import InputDropdown from '../../common/Forms/InputDropdown';
import {
  BudgetHeading,
  BudListing,
  InvoiceListing,
  CbpListHeading,
  ProgressCircular,
} from '../Invoice.Styled';
import Typography from '@mui/material/Typography';
import moment from 'moment';
import {
  formDateFormat, 
  INVOICE_URL,
  INVOICE_BASE_URL, 
  SET_RATES_URL, 
  CREATE_INVOICES_URL,
  COUNTY_LIST, 
  cbpListEnable,
  CBP_INVOICE_FAX_URL } from '../../../constants';
  import { getInvoices } from '../../../redux/invoices/invoicesSlice';
  import { setSelectedMonth } from '../../../redux/invoices/invoiceReferenceSlice';
  import {
    getCbpInvoiceIds,
    resetCbpInvoiceIds,
  } from '../../../redux/invoices/cbpInvoiceIdsSlice';
  import { postStopApi } from '../../../services/StopApi/StopApi';
  import Snackbar from '@mui/material/Snackbar';
  import Alert from '@mui/material/Alert';
  import { getCountyList, setFaxSentDate } from '../CbpInvoiceList/services/cbpInvoiceListApi';
  import YesNoPopup from '../../common/YesNoPopup/YesNoPopup';


  const InvoiceForm = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [user, setUser] = useState(null);
    const [selectedCbpList, setSelectedCbpList] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const [formLoading, setFormLoading] = useState(false);
    const [uosLoading, setUOSLoading] = useState(false);
    const [ratesSuccessMessage, setRatesSuccessMessage] = useState(false);
    const [invoiceSuccessMessage, setInvoiceSuccessMessage] = useState(false);
    const [directoryReportInput, setDirectoryReportInput] = useState(false);
    const [paroleReportInput, setParoleReportInput] = useState(false);
    const [uosReportInput, setUOSReportInput] = useState(false);
    const [countyList, setCountyList] = useState([]);
    const [faxProviderYesNoPopUp, setFaxProviderYesNoPopUp] = useState(false);
    const [closedFaxPrompt, setClosedFaxPrompt] = useState(false);

    const cBPIDs = selectedCbpList?.join();

    const invoiceReferenceData = useSelector(
      (state) => state.invoiceReferenceData?.data
      );
    const { selectedMonth, months } = invoiceReferenceData;

    const invoicesDetails = useSelector((state) => state.invoicesDetails?.data);
    const getInvoicesDetailsSucceeded = useSelector(
      (state) => state.invoicesDetails?.succeeded
      );

    useEffect(() => {
      if (closedFaxPrompt)
        handleProviderInvoicesPrint();
    }, [closedFaxPrompt]);

    useEffect(() => {
      getUser().then((userData) => setUser(userData));
    }, []);

    const getUser = () => {
      return Auth.currentAuthenticatedUser()
      .then((userData) => userData)
      .catch(() => console.log('Not signed in'));
    };

    useEffect(() => {
      if (user?.signInUserSession.accessToken.jwtToken) {
        if (selectedMonth) {
          fetchInvoices();
        }
        if (countyList.length==0)
          fetchCounties();
      }
    }, [user?.signInUserSession.accessToken.jwtToken, selectedMonth]);

    const handleFaxSent = () => {
      const url = `${CBP_INVOICE_FAX_URL}?selectedMonth=${selectedMonth}&CBPIds=${cBPIDs}`;
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      setFaxSentDate({ url, authorization }).then((response) => {
      });
    }

    const fetchInvoices = async () => {
      const commonParams = `${INVOICE_URL}/${selectedMonth}`;
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      dispatch(getInvoices({ commonParams, authorization }));
    };
    useEffect(() => {
      if (cBPIDs === '') {
        setButtonDisabled(true);
      }
    }, [cBPIDs]);

    const fetchCounties = async () => {
      const commonParams = COUNTY_LIST;
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      const countyList = await getCountyList({
        commonParams,
        authorization,
      });
      setCountyList(countyList.data);    
    };

    useEffect(() => {
      if (cBPIDs === '') {
        setButtonDisabled(true);
      }
    }, [cBPIDs]);

    useEffect(() => {
      if (getInvoicesDetailsSucceeded) {
        setFormLoading(false);
        dispatch(resetCbpInvoiceIds());
      }
    }, [formLoading, getInvoicesDetailsSucceeded]);

    const defaultValue = {
      selectedMonth: selectedMonth,
    };

    const useFunction = useForm({
      mode: 'onChange',
      defaultValues: defaultValue,
    //resolver: yupResolver(organizationValidation),
    });
    const { reset, control, register, formState } = useFunction;
    const { errors } = formState;

    useEffect(() => {
      reset(defaultValue);
    }, [defaultValue.selectedMonth]);

    const handleDirectorySubmit = (asOfDate) => {
      //console.log(asOfDate);
      navigate(`/report/directory/${asOfDate}`, {state:{asOfDate:asOfDate}});
    }

    const handleParoleSubmit = (startDate, endDate, county) => {
      //console.log(startDate);
      //console.log(endDate);
      //console.log(county);
      navigate(`/report/weekly/${startDate}/${endDate}/${county.id}`, {state:{startDate:startDate, endDate:endDate, countyID:county.id, countyName:county.value}});
    }

    const handleCbpListToggle = (id) => () => {
      const currentIndex = selectedCbpList.indexOf(id);
      const newChecked = [...selectedCbpList];

      if (currentIndex === -1) {
        newChecked.push(id);
        setButtonDisabled(false);
      } else {
        newChecked.splice(currentIndex, 1);
      }
      setSelectedCbpList(newChecked);
    };

    const handleCbpInvoices = () => {
      navigate(`/invoice/cbpInvoiceList/${cBPIDs}`);
      dispatch(getCbpInvoiceIds(cBPIDs));
    };

    const handleProviderInvoices = () => {
      setClosedFaxPrompt(false);
      setFaxProviderYesNoPopUp(true);
    };

    const handleProviderInvoicesPrint = () => {
      navigate(`/invoice/PrintInvoices`);
      dispatch(getCbpInvoiceIds(cBPIDs));
    };

    const handleTransportationInvoices = () => {
      navigate(`/invoice/transportationInvoiceList/555`);
    //dispatch(getCbpInvoiceIds(cBPIDs));
    };

    const handleOutOfMonthTreatments = () => {
      navigate(`/invoice/outOfMonthTreatmentsList`);
    };

    const handleCreditedTreatments = () => {
      navigate(`/invoice/creditedTreatmentsList`);
    };

    const handleRates = () => {
      var url = `${SET_RATES_URL}${selectedMonth}`;
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      return postStopApi({
        url,
        'payload': '',
        authorization,
      }).then((response) => {
        console.log("rates updated");
        setRatesSuccessMessage(true);
      }).catch((e) => alert(e));
    }

    const handleInvoiceListMod = () => {
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      const config = {
        headers: {
          Authorization: authorization,
          Region: process.env.REACT_APP_STOP_REGION,
        },
        responseType: 'blob',
      };
      
      axios.get(`${INVOICE_BASE_URL}ListExcel/${selectedMonth}`, config)
      .then((res) => {
        fileDownload(res.data, selectedMonth + '.xlsx')
      })
      .catch((error) => console.log(error));
    }

    const handleUOSSubmit = (startDate, endDate) => {
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      const REGION = process.env.REACT_APP_STOP_REGION;
      const config = {
        headers: {
          Authorization: authorization,
          Region: REGION,
        },
        responseType: 'blob',
      };
      
      setUOSLoading(true);      
      axios.get(`${INVOICE_BASE_URL}uos/${startDate}/${endDate}/${REGION}`, config)
      .then((res) => {
        setUOSLoading(false);
        fileDownload(res.data, 'uos.xlsx')
      })
      .catch((error) => {
        setUOSLoading(false);
        console.log(error)
      });
    }
    
    const handleInvoices = () => {
      
      var url = `${CREATE_INVOICES_URL}${selectedMonth}`;
      const authorization = `${user?.signInUserSession.accessToken.jwtToken}`;
      return postStopApi({
        url,
        'payload': '',
        authorization,
      }).then((response) => {
        console.log("invoices created");
        fetchInvoices();
        setInvoiceSuccessMessage(true);
      }).catch((e) => alert(e));
    }

    const closeRatesMessage = () => setRatesSuccessMessage(false);
    const closeInvoicesMessage = () => setInvoiceSuccessMessage(false);

    const getForm = () => {
      return (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <InputDropdown
            name='selectedMonth'
            control={control}
            options={months}
            defaultId={defaultValue?.month}
            monthId={true}
            register={register('selectedMonth', {
              onChange: (e) => dispatch(setSelectedMonth(e.target.value)),
            })}
            label='Month'
            />
          </Grid>
          <Grid item xs={12} sm={9}>
            <Button 
              variant='contained'
              onClick={() => handleInvoiceListMod()}
            >
              Invoice List by Modality
            </Button>
            {uosLoading &&
              <CircularProgress sx={{'marginLeft': '6px;'}}/>
            }  
            {!uosLoading &&
              <Button 
                sx={{'marginLeft': '6px;'}} 
                variant='contained'
                onClick={() => setUOSReportInput(true)}
              >
                Units of Service
              </Button>
            }  
            <Button
              sx={{'marginLeft': '6px;'}} 
              variant='contained'
              onClick={() => setDirectoryReportInput(true)}
            >
              Directory
            </Button>
            <Button 
              sx={{'marginLeft': '6px;'}} 
              variant='contained'
              onClick={() => setParoleReportInput(true)}
            >
              Weekly Parole by County
            </Button>
          </Grid>          
        </Grid>
        );
    };
    const getBudgetList = () => {
      return (
        <>
        {formLoading ? (
          <ProgressCircular>
          <CircularProgress />
          </ProgressCircular>
          ) : (
          <>
          <BudgetHeading variant='h5' pt={2}>
            Budget/Authorization Type (leave blank for all )
          </BudgetHeading>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <BudListing>
              {invoicesDetails?.budgetOrAuthorizationTypes?.map(
                (item, index) => {
                  const labelId = `checkbox-list-label-${item.value}`;
                  return (
                    <ListItem key={index} disablePadding>
                    <ListItemText
                    id={labelId}
                    primary={`${item.value}`}
                    />
                    </ListItem>
                    );
                }
                )}
              </BudListing>
            </Grid>
          </Grid>
          <Snackbar 
          open={ratesSuccessMessage} 
          autoHideDuration={3000} 
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={closeRatesMessage}
          >
          <Alert 
          severity="success"
          onClose={closeRatesMessage}
          >
          Rates Updated!
          </Alert>
          </Snackbar>
          <Snackbar 
          open={invoiceSuccessMessage} 
          autoHideDuration={3000} 
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          onClose={closeInvoicesMessage}
          >
          <Alert 
          severity="success"
          onClose={closeInvoicesMessage}
          >
          Invoices Created!
          </Alert>
          </Snackbar>
          </>
          )}
          </>
          );
    };

    const getBudgetButtons = () => {
      return (
        <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={2.4}>
        {
        /*
        <Button variant='contained'>Budget Report</Button>
        */
        }
        </Grid>
        <Grid item xs={12} sm={5}>
        <Button 
        variant='contained'
        onClick={() => handleRates()}
        >
        Apply Treatment/Transportation Rates
        </Button>
        </Grid>
        <Grid item xs={12} sm={3}>
        <Button 
        variant='contained'
        onClick={() => handleInvoices()}
        >
        Create/Reset Invoices
        </Button>
        </Grid>
        </Grid>
        );
    };

    const getCBPList = () => {
      return (
        <>
        {formLoading ? (
          <ProgressCircular>
          <CircularProgress />
          </ProgressCircular>
          ) : (
          <>
          <CbpListHeading variant='h5'>
          Filter by CBP (leave blank for all )
          </CbpListHeading>
          <Typography variant='h6'>CBO Name and Id</Typography>
          <Grid container spacing={2}>
          <Grid item xs={12}>
          <InvoiceListing>
          {invoicesDetails?.cbpList?.map((item, index) => {
            return (
              <ListItem key={index} disablePadding>
              <ListItemButton
              role={undefined}
              onClick={handleCbpListToggle(item.id)}
              dense
              >
              <ListItemIcon>
              <Checkbox
              edge='start'
              checked={selectedCbpList.indexOf(item.id) !== -1}
              tabIndex={-1}
              disableRipple
              />
              </ListItemIcon>
              <Grid container>
              <Grid item xs={12} sm={11.5}>
              <ListItemText
              disableTypography
              primary={`${item.value}`}
              />
              </Grid>
              <Grid item xs={12} sm={0.5}>
              <ListItemText
              disableTypography
              primary={`${item.id}`}
              />
              </Grid>
              </Grid>
              </ListItemButton>
              </ListItem>
              );
          })}
          </InvoiceListing>
          </Grid>
          </Grid>
          </>
          )}
          </>
          );
    };

    const getCBPButtons = () => {
      return (
        <Grid container spacing={2} style={{ marginTop: '0px' }}>
        <Grid item xs={12} sm={2.4}>
        <Tooltip
        title={buttonDisabled ? cbpListEnable : ''}
        placement='top'
        arrow
        >
        <span>
        <Button
        //disabled={buttonDisabled}
        variant='contained'
        onClick={() => handleCbpInvoices()}
        >
        CBP Invoices
        </Button>
        </span>
        </Tooltip>
        </Grid>
        <Grid item xs={12} sm={2.4}>
        <Button
        variant='contained'
        onClick={() => handleTransportationInvoices()}
        >
        Transportation Invoices
        </Button>
        </Grid>
        <Grid item xs={12} sm={2.4}>
        <Button 
        variant='contained'
        onClick={() => handleProviderInvoices()}
        >
        Provider Invoices By CBP</Button>
        </Grid>
        <Grid item xs={12} sm={2.4}>
          <Button variant='contained' onClick={() => handleOutOfMonthTreatments()}>Out of Month Treatments</Button>
        </Grid>
        <Grid item xs={12} sm={2.4}>
          <Button variant='contained' onClick={() => handleCreditedTreatments()}>Credited Treatments</Button>
        </Grid>
        </Grid>
        );
    };

    return (
      <>
      {getForm()}
      {getBudgetList()}
      {getBudgetButtons()}
      {getCBPList()}
      {getCBPButtons()}
      <AsOfDate
        cancelPopUp={directoryReportInput}
        setCancelPopUp={setDirectoryReportInput}
        title='Directory Report'
        submit={handleDirectorySubmit}
      >  
      </AsOfDate>
      <StartEndCounty
        cancelPopUp={paroleReportInput}
        setCancelPopUp={setParoleReportInput}
        title='Parole by County'
        countyList={countyList}
        submit={handleParoleSubmit}
      >  
      </StartEndCounty>
      <StartEnd
        cancelPopUp={uosReportInput}
        setCancelPopUp={setUOSReportInput}
        title='Units of Service'
        submit={handleUOSSubmit}
      >  
      </StartEnd>
      <YesNoPopup
        message='Will these Invoices be faxed to the Provider for verification?'
        yesHandler={handleFaxSent}
        setPopUp={setFaxProviderYesNoPopUp}
        popUp={faxProviderYesNoPopUp}
        setClosedFaxPrompt={setClosedFaxPrompt}
      />
      </>
      );
  };

  export default InvoiceForm;
